export const INIT_LATEST_NEW = "INIT_LATEST_NEW";
export const FETCH_LATEST_NEW_SUCCES = "FETCH_LATEST_NEW_SUCCES";
export const FETCH_LATEST_NEW_FAIL = "FETCH_LATEST_NEW_FAIL";

export const INIT_TOP_NEW = "INIT_TOP_NEW";
export const FETCH_TOP_NEW_SUCCES = "FETCH_TOP_NEW_SUCCES";
export const FETCH_TOP_NEW_FAIL = "FETCH_TOP_NEW_FAIL";

export const INIT_NEW_BY_COIN = "INIT_NEW_BY_COIN";
export const FETCH_NEW_BY_COIN_SUCCES = "FETCH_NEW_BY_COIN_SUCCES";
export const FETCH_NEW_BY_COIN_FAIL = "FETCH_NEW_BY_COIN_FAIL";
